import { IFirmwareConfig } from ".";

export const DR900S_1CH = {
  default: {
    Time: {
      GpsSync: {},
      TimeSet: {},
    },
    Video: {
      ImageSetting: {
        options: [
          { key: "0", value: "4K UHD @30(Extreme)" },
          { key: "1", value: "4K UHD @30" },
          { key: "2", value: "FHD @60" },
          { key: "3", value: "FHD @30" },
        ],
      },

      VideoQuality: {
        options: [
          { key: "0", value: "Highest" },
          { key: "1", value: "High" },
          { key: "2", value: "Normal" },
        ],
        options4k: [{ key: "0", value: "Highest (Extreme)" }],
      },
      VCodecType: {},
      NightVision: {
        options: [
          { key: "1", value: "Always" },
          { key: "2", value: "Parking mode only" },
        ],
      },
      FrontBrightness: {},
    },

    Recording: {
      NormalRecord: {},
      AutoParking: {},
      VoiceRecord: {},
      DateDisplay: {},
      SpeedUnit: {},
      UseGpsInfo: {},
      RecordTime: {
        options: [
          {
            key: "1",
            value: "1 min",
          },
          {
            key: "2",
            value: "2 min",
          },
          {
            key: "3",
            value: "3 min",
          },
        ],
        options4k: [
          {
            key: "1",
            value: "1 min (Extreme)",
          },
        ],
      },
      LockEvent: {},
      overWriteLock: {},
      FrontRotate: {},
    },
    Gsensor: {
      Normal: {},
      Parking: {},
    },
    MotionDetection: {
      MOTIONSENSOR: {},
    },
    System: {
      LED: {
        RECLED: {},
        NORMALLED: {},
        PARKINGLED: {},
        WifiLED: {},
      },
      PSENSOR: {},
      VoiceGuidance: {
        STARTVOICE: {},
        NORMALSTARTVOICE: {},
        EVENTSTARTVOICE: {},
        CHANGERECORDMODEVOICE: {},
        ENDVOICE: {},
        SPEEDALERTVOICE: {},
        PARKINGEVENTVOICE: {},
        CLOUDVOICE: {},
        CHANGECONFIGVOICE: {},
        SHARPTURNVOICE: {},
        HARSHBRAKINGVOICE: {},
        ACCELERATIONVOICE: {},
      },
      VOLUME: {},
      ScheduledReboot: {},
      SpeedAlert: {},
      //BatteryProtection: {},
      UserTextOverlay: {},
    },
    Wifi: {
      LoginCredentials: {},
      WifiBand: {},
      WifiSleepMode: {},
      onstart: {},
      // onstart_LTE: {},
    },
    Cloud: { CloudService: {}, sta1: {}, sta2: {}, sta3: {} },
    FirmwareLanguage: [
      "English",
      "Japan",
      "China",
      "German",
      "French",
      "Thai",
      "Idn",
      "Vietnam",
      "Spain",
      "Italian",
      "Dutch",
      "Polish",
      "Norwegian",
      "Finnish",
    ],
  } as IFirmwareConfig,
  1.014: {
    System: {
      EventRev: {},
    },
  } as IFirmwareConfig,
};
